import { FC } from 'react';
import CustomCard from '@components/CustomCard';
import VerifyEmail from '@components/VerifyEmail';

const PaywallValidateEmail: FC = () => (
    <CustomCard dataTestId="paywall-validate-email" mainContent={<VerifyEmail />} withFadeContent />
);

export default PaywallValidateEmail;
